import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const whatsappWebhook = async (data) => {
  const URL = `${BASE_URL}whatsapp/webhook`

  const rawBody = JSON.stringify(data)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}

export const getMessagesByTalentPaginated = ({ page = 0, talentId }) => {
  const URL = `${BASE_URL}whatsapp/getMessagesByTalentPaginated?page=${page}${talentId ? `&talentId=${talentId}` : ''}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const getMessagesByTalent = ({ page = 0, talentId }) => {
  const URL = `${BASE_URL}whatsapp/getMessagesByTalent?page=${page}&talentId=${talentId}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const initializeBoot = async ({ talentId, offerId, promptQuestionId, templeteName = null }) => {
  const URL = `${BASE_URL}whatsapp/initializeBoot`

  const rawBody = JSON.stringify({ talentId, offerId, promptQuestionId, templeteName })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
    return { response: null, res: null, error }
  }
}

export const initializeChat = async ({ talentId, templeteName = null }) => {
  const URL = `${BASE_URL}whatsapp/initializeChat`

  const rawBody = JSON.stringify({ talentId, templeteName })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
    return { response: null, res: null, error }
  }
}

export const searchChatsByTalent = ({ talentSearch }) => {
  const URL = `${BASE_URL}whatsapp/searchChatsByTalent?talentSearch=${encodeURIComponent(talentSearch)}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res?.result)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const sendWhatsappMessage = async ({ talentId, message }) => {
  const URL = `${BASE_URL}whatsapp/sendMessage`

  const rawBody = JSON.stringify({ talentId, message })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    const res = await response.json()

    return { response, res }
  } catch (error) {
    console.log(error)
  }
}
